import React from 'react';
import{BrowserRouter,Routes,Route} from 'react-router-dom'
import Home from './home';
import PropertyDetails from './property-details';
import Error from './error';
import PropList from './propertylist';
import VR from './vr';
const Routess = () => {
    return ( <>
        <BrowserRouter>
        <Routes>
            <Route path='/' element={<Home />} />
            <Route path='list' element={<PropList />} />

            <Route path='property' element={<PropertyDetails />} />
            <Route path='*' element={<Error />} />
            <Route path='vr' element={<VR />} />


        </Routes>
        </BrowserRouter>
        </>
     );
}
 
export default Routess;